<template>
  <article class="page-offline-service">
    <!-- chart panel -->
    <crm-panel class="chart-panel">
      <!-- total time -->
      <section class="tips-container">
        <span class="tips-container_text">数据统计于{{ totalTime }}</span>
      </section>
      <!-- toolbar -->
      <section class="select-container">
        <el-form :inline="true">
          <span class="select-container_label">线下服务统计</span>
          <el-form-item>
            <el-select
              v-model="timeRangeAlias"
              @change="handleTimeRangeChange($event)"
            >
              <chart-total-time-options />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-show="isShown"
              v-model="time"
              value-format="yyyy-MM-dd"
              :editable="false"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-select
              clearable
              placeholder="服务类型"
              v-model="tableSearchForm.serviceName"
              @change="handleTimeRangeChange()"
            >
              <el-option
                v-for="item in serviceType"
                :label="item.name"
                :value="item.name"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div class="select-container_buttons">
          <crm-button
            v-if="
              auth.sdOrderCostOfflineDownload &&
                auth.sdOrderCostOfflineDownload.toggleStatus
            "
            buttonType="plain"
            text="导出"
            @click="handleExport()"
          >
          </crm-button>
        </div>
      </section>
      <!-- total block -->
      <section class="total-container">
        <div
          class="total-container_block"
          v-for="totalBlock in totalBlockList"
          :key="totalBlock.tipText"
        >
          <crm-block v-bind="totalBlock" />
        </div>
      </section>
      <!-- chart -->
      <section class="chart-container" />
    </crm-panel>

    <!-- table panel -->
    <crm-panel class="table-panel">
      <!-- table -->
      <el-table
        :data="tableData.results"
        border
        v-loading="loading"
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          prop="orderId"
          width="150"
          label="订单ID"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="serviceName" label="服务类型" align="center">
        </el-table-column>
        <el-table-column
          prop="hospital"
          width="200"
          show-overflow-tooltip
          label="就诊医院"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="department" label="就诊科室" align="center">
        </el-table-column>
        <el-table-column prop="serviceCost" label="服务成本" align="center">
        </el-table-column>
      </el-table>
      <!-- pageination -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="tableSearchForm.pageNumber"
          :page-sizes="[10, 20, 50]"
          :page-size="tableSearchForm.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="tableData.totalCount"
        >
        </el-pagination>
      </div>
    </crm-panel>
  </article>
</template>

<script>
import moment from 'moment';
import * as echarts from 'echarts/echarts.common';
import { mapActions, mapGetters } from 'vuex';
import { serviceCount } from 'crm-common';

import { downloadByUrl, conversion } from '@/scripts/utils';
import http from '~services/axios';
import CHART_API_CONFIG from '~api/statistics/service-api-config';
import getTimeRangeByAlias from '~services/time-range';

import ChartTotalTimeOptions from '@/components/business/datastatistics/chart-total-time-options';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import CrmBlock from '@/components/base/crmBlock';

const { apiFactory, chartFactory: optionFactory } = serviceCount;
const diagramCommonApi = apiFactory(http, CHART_API_CONFIG);

// crm-common包中对每个图表定义的名称
const CHART_NAME = 'serviceOfOffline';

/**
 * TABLE_GETTER_NAME: vuex-store里对应的表格数据getter名称
 * TABLE_ACTION_NAME: vuex-store里对应的表格数据获取action名称
 *  */
const TABLE_GETTER_NAME = 'offlineServiceTableData';
const TABLE_ACTION_NAME = 'getOfflineServiceTableData';

// echarts instance
let chart;
const echartsConfig = {
  devicePixelRatio: window.devicePixelRatio,
};
const defaultDataFormat = 'YYYY-MM-DD';

export default {
  components: {
    CrmPanel,
    CrmButton,
    CrmBlock,
    ChartTotalTimeOptions,
  },
  filters: {
    conversion,
  },
  data() {
    const chartSearchForm = {
      startDate: moment()
        .startOf('month')
        .format(defaultDataFormat),
      endDate: moment()
        .endOf('month')
        .format(defaultDataFormat),
    };
    const yestoday = moment()
      .dates(moment().date() - 1)
      .format(defaultDataFormat);

    return {
      loading: false,
      isShown: false,
      time: [],
      totalTime: yestoday,
      timeRangeAlias: 'this-month',
      totalBlockList: [],
      chartSearchForm,
      tableSearchForm: {
        ...chartSearchForm,
        serviceName: null,
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  computed: {
    ...mapGetters('authority', {
      auth: 'auth',
    }),
    ...mapGetters('statistics', {
      tableData: TABLE_GETTER_NAME,
    }),
    ...mapGetters('common', {
      serviceType: 'serviceType',
    }),
  },
  created() {
    this.getServiceType({
      pageNumber: 1,
      pageSize: 100,
      code: 'category_offline_service_type',
    });
  },
  mounted() {
    const chartContaiter = document.querySelector('.chart-container');
    chart = echarts.init(chartContaiter, 'light', echartsConfig);
    this.getDiagram();
    this.getTable();
  },
  watch: {
    time: {
      handler: 'handleSelfTimeSearch',
    },
  },
  methods: {
    ...mapActions('statistics', {
      getTableData: TABLE_ACTION_NAME,
    }),
    ...mapActions('common', {
      getServiceType: 'getServiceType',
    }),
    renderTotalTime() {
      this.totalTime = moment()
        .dates(moment().date() - 1)
        .format(defaultDataFormat);
    },
    handleTimeRangeChange(timeAlias = this.timeRangeAlias) {
      if (timeAlias === 'self-time') {
        this.isShown = true;
      } else {
        this.isShown = false;
        const { startTime, endTime } = getTimeRangeByAlias(
          timeAlias,
          'YYYY-MM-DD',
        );
        this.chartSearchForm = {
          ...this.chartSearchForm,
          startDate: startTime,
          endDate: endTime,
        };
        this.tableSearchForm = {
          ...this.tableSearchForm,
          startDate: startTime,
          endDate: endTime,
        };
        this.getDiagram();
        this.getTable();
      }
    },
    handleSelfTimeSearch() {
      this.chartSearchForm = {
        ...this.chartSearchForm,
        startDate: this.time[0],
        endDate: this.time[1],
      };
      this.tableSearchForm = {
        ...this.tableSearchForm,
        startDate: this.time[0],
        endDate: this.time[1],
      };
      this.getDiagram();
      this.getTable();
    },
    renderChart(data) {
      const option = optionFactory(CHART_NAME, data);
      chart.setOption(option);
    },
    // chart ajax
    getDiagram() {
      diagramCommonApi(CHART_NAME, this.chartSearchForm).then((res) => {
        const { data: results } = res.data;
        this.renderTotalTime();
        this.renderChart(results);
      });
    },
    // table ajax
    getTable() {
      this.loading = false;
      this.getTableData(this.tableSearchForm).finally(() => {
        this.loading = false;
      });
    },
    handleSizeChange(val) {
      this.tableSearchForm.pageSize = val;
      this.tableSearchForm.pageNumber = 1;

      this.getTable();
    },
    handleCurrentChange(val) {
      this.tableSearchForm.pageNumber = val;
      this.getTable();
    },
    handleExport() {
      const params = this.tableSearchForm;
      this.notify = this.$notify({
        iconClass: 'el-icon-loading',
        title: '',
        message: '正在导出中，请稍后...',
        duration: 0,
        showClose: false,
      });

      let url = '/api/serviceData/download/orderCost/offline?';
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });

      downloadByUrl(url);
      if (this.notify) this.notify.close();
    },
  },
};
</script>

<style lang="less" scoped>
.page-offline-service {
  width: 100%;

  // 图表面板
  .chart-panel {
    padding: 0;
    .tips-container {
      background: rgba(240, 183, 98, 0.1);
      height: 28px;
      line-height: 28px;
      &_text {
        padding-left: 20px;
        color: #7a84b7;
      }
    }
    .select-container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px;
      &_label {
        line-height: 42px;
        font-size: 24px;
        color: #7a84b7;
        padding-right: 30px;
      }
    }
    .total-container {
      display: flex;
      flex-wrap: wrap;
      &_block {
        margin-left: 20px;
        margin-bottom: 20px;
      }
    }
    .chart-container {
      margin: 0 20px 20px 20px;
      height: 220px;
    }
  }

  // 表格面板
  .table-panel {
    margin-top: 20px;
    height: 400px;
  }
}
</style>
